// Scroll animation

// Handle scroll-triggered animations
const scrollElements = document.querySelectorAll(".js-scroll");

const elementInView = (el, dividend = 1) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop <=
    (window.innerHeight || document.documentElement.clientHeight) / dividend
  );
};

const elementOutofView = (el) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop > (window.innerHeight || document.documentElement.clientHeight)
  );
};

const displayScrollElement = (element) => {
  element.classList.add("scrolled");
};

const hideScrollElement = (element) => {
  element.classList.remove("scrolled");
};

const handleScrollAnimation = () => {
  scrollElements.forEach((el) => {
    if (elementInView(el, 1.25)) {
      displayScrollElement(el);
    } else if (elementOutofView(el)) {
      hideScrollElement(el);
    }
  });
};

window.addEventListener("scroll", () => {
  handleScrollAnimation();
});

// Handle load-triggered animations
const loadElements = document.querySelectorAll(".first-animation");

const displayLoadElement = (element) => {
  element.classList.add("loaded");
};

const handleLoadAnimation = () => {
  loadElements.forEach((el) => {
    displayLoadElement(el);
  });
};

window.addEventListener("load", () => {
  handleLoadAnimation();
});


// Accordion
document.querySelectorAll('.section-accordion-sticky .accordion-section').forEach((section) => {
  // Get the unique section ID from the class name
  const sectionId = section.classList[2].split('-')[1];

  // Target only the h3 elements within this specific section
  section.querySelectorAll('.accordion_item_flex h3').forEach((item) => {
      item.addEventListener('click', function () {
      let accordionItem = this.closest('.accordion_item');
      let content = accordionItem.querySelector('.accordion_content');

      // Check if the clicked accordion is already active
      if (accordionItem.classList.contains('active')) {
          // Remove active class and collapse content
          accordionItem.classList.remove('active');
          content.style.maxHeight = null; // Collapse
      } else {
          // Remove active class from all other accordion items within the same section
          section.querySelectorAll('.accordion_item').forEach((accordion) => {
          accordion.classList.remove('active');
          accordion.querySelector('.accordion_content').style.maxHeight = null; // Collapse
          });

          // Add active class to the clicked accordion item and expand content
          accordionItem.classList.add('active');
          content.style.maxHeight = content.scrollHeight + 'px'; // Expand
      }
      });
  });
});


// Tab 
document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".tab_title_wrapper button");
  const tabContentItems = document.querySelectorAll(".tab_content_block_item");

  buttons.forEach((button) => {
      button.addEventListener("click", () => {
          const id = button.getAttribute("data-id");

          buttons.forEach((btn) => btn.classList.remove("active"));

          tabContentItems.forEach((item) => item.classList.remove("active"));

          button.classList.add("active");

          const targetContent = document.querySelector(`.tab_content_block_item[data-id="${id}"]`);
          if (targetContent) {
              targetContent.classList.add("active");
          }
      });
  });
});
